define.alias("shared/components/shared/button/copy", "calendar/components/shared/button/copy");